// Import Olympe runtime or DRAW
import 'olympe';

// Import project bricks (we use webpack-import-glob-loader to import all bricks)
;
import './web/camera/GetVideoStream.js'; import './web/camera/TakePicture.js'; import './web/GetImageSize.js';
import './web/camera/Video.jsx'; import './web/zoomist/zoomablePanel.jsx';

